import { useTranslation } from 'react-i18next';

const AutoReplyMessage = () => {
	const { t } = useTranslation();
	return (
		<div className={`auto-reply-message`}>
			<div className='conversation-message-content'>
				{t('thankYouForReachingOutWeWillReplyToYourMessageSoonIfYouOrSomeoneYouKnowIsInImmediateDangerPleaseCallEmergencyServices')}
			</div>
			<div className='message-deliver-info'></div>
		</div>
	);
};

export default AutoReplyMessage;
